var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiBoneHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.52 18.91a1.625 1.625 0 01-1.038.246A1.694 1.694 0 017.96 17.42c.011-.311-.253-.697-.536-.827a1.362 1.362 0 01-.79-1.19c-.008-.25.057-.495.185-.707.662-1.068 2.057-.222 3.584-1.75 2.579-2.578 3.993-3.563 3.975-5.634-.003-.25.052-.497.16-.72a1.597 1.597 0 011.129-.877c.244-.049.497-.042.741.022a1.7 1.7 0 011.268 1.67 1.64 1.64 0 01-.019.212c-.033.218.148.474.362.53a1.353 1.353 0 01.97 1.652 1.285 1.285 0 01-1.14.94c-2.083.196-2.595 1.128-5.303 3.836-2.037 2.037-.618 3.41-2.026 4.332z",
    fill: "#31544e"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--bone-health-c4862b2e408b5306ceab588de69810ab.svg";
export { SvgIconUiBoneHealth as Component };